





























































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Contract as IContract } from "@/api/models/contract";
import { ContractShort as IContractShort } from "@/api/models/contract-short";
import {
  AnnexEdit as IAnnexEdit,
  AnnexEditTypeEnum
} from "@/api/models/annex-edit";
import {
  ContractEdit as IContractEdit,
  ContractEditTypeEnum
} from "@/api/models/contract-edit";
import BillForm from "@/components/bill/BillForm.vue";
import api from "@/getinfo-api";
import OrderItemPreview from "@/components/orders/OrderItemPreview.vue";
import ActForm from "@/components/act/ActForm.vue";
import { ActShort as IAct } from "@/api/models/act-short";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { BillShort as IBill } from "@/api/models/bill-short";
import { BillShortList as IBillList } from "@/api/models/bill-short-list";
import bills, { BillListParams } from "@/getinfo-api/bills";
import acts, { ActListParams } from "@/getinfo-api/acts";
import BillItemPreview from "@/components/bill/BillItemPreview.vue";
import ActItemPreview from "@/components/act/ActItemPreview.vue";
import { Contractor as IContractor } from "@/api/models/contractor";
import { User as IUser } from "@/api/models/user";
import ContractFormLearningResourceTable from "@/components/contract/ContractFormLearningResourceTable.vue";
import CheckedUsersForInvite from "@/components/invite-users/CheckedUsersForInvite.vue";
import { isRoot } from "@/plugins/roles";
import CPage from "@/components/form/CustomPage/CPage.vue";
import { IPageSettings } from "@/plugins/custom-interface";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import FileManager from "@/components/files/FileManager.vue";
import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import DocumentArchiveButton from "@/components/form/DocumentArchiveButton.vue";
import contracts, { ContractsListParams } from "@/getinfo-api/contracts";
import AnnexList from "@/components/contract/AnnexList.vue";
import { generatePdf } from "@/utils/files-helper";
import DocTemplateGenerateV2 from "@/components/doc-tempates/DocTemplateGenerateV2.vue";
import { agentsModule } from "@/plugins/modules-detect";
import { ContractSort, SortFields } from "@/plugins/sort-fields";
import CField from "@/components/form/CField.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: {
    CustomButton,
    CField,
    DocTemplateGenerateV2,
    AnnexList,
    DocumentArchiveButton,
    EntityFiles,
    FileManager,
    TextField,
    CBlock,
    CPage,
    ContractFormLearningResourceTable,
    ActItemPreview,
    BillItemPreview,
    ActForm,
    BillForm,
    OrderItemPreview,
    CheckedUsersForInvite
  }
})
export default class ContractView extends Vue {
  contract!: IContract;
  showBillForm: boolean = false;
  showActForm: boolean = false;
  acts?: Array<IAct> = [];
  bills?: Array<IBill>;
  contractor!: IContractor;
  user!: IUser;
  isLoadingFiles: boolean = false;
  annexes: Array<IContractShort> = [];
  isCheckAnnexes: boolean = false;
  limit: number = 30;
  offset: number = 0;
  annexesCount: number = 0;
  sorted: SortFields<ContractSort> = new SortFields(ContractSort.formedAt);
  acceptSort(sort: ContractSort) {
    this.sorted.changeSort(sort);
    this.limit = 30;
    this.offset = 0;
    this.annexes = [];
    this.getAnnexes(this.offset);
  }

  annexParams: ContractsListParams = {
    number: "",
    formedAtMax: undefined,
    formedAtMin: undefined
  };

  acceptAnnexFilter() {
    this.limit = 30;
    this.offset = 0;
    this.annexes = [];
    this.getAnnexes(this.offset);
  }

  get sortStatus() {
    return ContractSort;
  }

  data() {
    return {
      contract: undefined,
      bills: undefined,
      contractor: undefined,
      contractStatus: undefined,
      acts: undefined,
      user: undefined
    };
  }

  create() {
    this.$router.push({
      name: "createContract",
      params: { contractId: this.contract.id },
      query: { contractId: this.contract.id }
    });
  }

  translateName(name: string) {
    if (name === "annex") {
      return `${this.$tc(this.$translate.ContractAddendum)} `;
    } else {
      return `${this.$tc(this.$translate.Contract)} `;
    }
  }

  updateActFiles(act: IAct) {
    let index = this.acts!.findIndex(act => act.id === act.id);
    this.acts![index].files = act.files;
  }

  updateBillFiles(bill: IBill) {
    let index = this.bills!.findIndex(bill => bill.id === bill.id);
    this.bills![index].files = bill.files;
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "contracts" },
        label: this.$tc(this.$translate.Contracts)
      },
      {
        label: this.contract.number
      }
    ];
  }

  get isAgentModuleEnabled() {
    return agentsModule();
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get prop(): IPageSettings {
    return {
      header: this.contract ? this.contract.number : "",
      headerIcon: "edit",
      headerIconTo: {
        name: "contractEdit",
        params: { contractId: this.contract.id }
      },
      isShowIcon: true
    };
  }

  get root() {
    return isRoot();
  }

  async _generatePdf(file: any) {
    this.isLoadingFiles = true;
    const response = await generatePdf(file)
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        const { message } = err;
        this.$bvToast.toast(message, {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        });
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
    this.addFiles([response.id], true);
  }

  addFiles(files: any, fromDocTemplate: boolean = false) {
    if (this.contract.type === "contract") {
      let params: IContractEdit = {
        type: this.contract.type
          ? (this.contract.type as ContractEditTypeEnum)
          : ContractEditTypeEnum.Contract,
        companyId: this.contract.companyId,
        agentId: this.contract.agentId,
        conditionId: this.contract.conditionId,
        number: this.contract.number,
        responsibleId: this.contract.responsible
          ? this.contract.responsible.id
          : undefined,
        contractorId: this.contract.contractor
          ? this.contract.contractor.id
          : undefined,
        userIds: this.contract.users?.map(el => el.id),
        learningResources: this.contract.learningResources,
        comment: this.contract.comment,
        paymentConditions: this.contract.paymentConditions,
        fileIds:
          this.contract.files && fromDocTemplate
            ? [...this.contract.files.map((el: any) => el.id), ...files]
            : [...files],
        signedAt: this.contract.signedAt,
        formedAt: this.contract.formedAt ?? new Date()
      };

      this.isLoadingFiles = true;

      api.ContractApi.edit(this.contract.id, params)
        .then((res: { data: IContract }) => {
          this.contract = res.data;
        })
        .finally(() => {
          this.isLoadingFiles = false;
        });
    }

    if (this.contract.type === "annex") {
      let params: IAnnexEdit = {
        //@ts-ignore
        contractId: this.contract.contract.id,
        learningResources: this.contract.learningResources,
        type: this.contract.type
          ? (this.contract.type as AnnexEditTypeEnum)
          : AnnexEditTypeEnum.Annex,
        companyId: this.contract.companyId,
        clientType: this.contract.clientType,
        clientId: this.contract.clientId,
        number: this.contract.number,
        responsibleId: this.contract.responsible
          ? this.contract.responsible.id
          : undefined,
        contractorId: this.contract.contractor
          ? this.contract.contractor.id
          : undefined,
        userIds: this.contract.users?.map(el => el.id),
        paymentConditions: this.contract.paymentConditions,
        agentId: this.contract.agentId,
        conditionId: this.contract.conditionId,
        comment: this.contract.comment,
        fileIds:
          this.contract.files && fromDocTemplate
            ? [...this.contract.files.map((el: any) => el.id), ...files]
            : [...files],
        signedAt: this.contract.signedAt,
        formedAt: this.contract.formedAt ?? new Date()
      };

      this.isLoadingFiles = true;
      //@ts-ignore
      api.ContractApi.edit(this.contract.id, params)
        .then((res: { data: IContract }) => {
          this.contract = res.data;
        })
        .finally(() => {
          this.isLoadingFiles = false;
        });
    }
  }

  getContract() {
    this.annexes = [];
    this.showBillForm = false;
    api.ContractApi.get(this.$route.params.contractId)
      .then((res: { data: IContract }) => {
        this.contract = res.data;
        document.title += ` ${this.contract.number}`;

        if (this.contract.actIds && this.contract.actIds.length > 0) {
          this.getActs();
        }

        this.getBills();
        this.contract.clientType === "user"
          ? this.getUser()
          : this.getContractor();

        if (this.contract.type === "contract") {
          this.getAnnexes();
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get status() {
    return !!this.contract?.signedAt;
  }

  getAnnexes(offset: number = 0) {
    this.isCheckAnnexes = true;
    const params: ContractsListParams = {
      companyId: this.contract.companyId,
      type: "annex",
      number: this.annexParams.number,
      formedAtMin: this.annexParams.formedAtMin,
      formedAtMax: this.annexParams.formedAtMax,
      contractId: this.contract.id,
      sort: this.sorted.sort,
      order: this.sorted.order,
      offset: offset,
      limit: this.limit
    };
    contracts(params)
      .then(
        res => (
          (this.annexes = [...this.annexes, ...res.data.items]),
          (this.annexesCount = res.data.count)
        )
      )
      .finally(() => (this.isCheckAnnexes = false));
  }

  showMoreAnnexes() {
    this.offset += this.limit;
    this.getAnnexes(this.offset);
  }

  getBills() {
    let params: BillListParams = {
      contractId: this.contract.id,
      companyId: this.contract.companyId,
      limit: 999
    };

    bills(params).then((res: { data: IBillList }) => {
      this.bills = res.data.items;
    });
  }

  async getActs() {
    this.acts = [];

    const params: ActListParams = {
      contractId: this.contract.id,
      companyId: this.contract.companyId,
      limit: 999
    };

    const { data } = await acts(params);
    this.acts = data.items;
  }

  getContractor() {
    if (this.contract.clientId) {
      api.ContractorApi.get(this.contract.clientId).then(
        (res: { data: IContractor }) => {
          this.contractor = res.data;
        }
      );
    }
  }

  @Watch("$route")
  updatePage() {
    if (this.$route.params.type) {
      document.title = "";
      document.title = `${this.$tc(this.$translate.ContractAddendum)}`;
    } else {
      document.title = `${this.$tc(this.$translate.Contract)}`;
    }

    this.getContract();
  }

  getUser() {
    if (this.contract.clientId) {
      api.UsersApi.get(this.contract.clientId).then((res: { data: IUser }) => {
        this.user = res.data;
      });
    }
  }

  updateAct() {
    this.showActForm = false;
    this.getContract();
  }

  created() {
    this.getContract();
  }
}
